import { ViewItem } from "./ViewItem";
export class ViewFolderItem extends ViewItem {
    get isGroup() {
        return (true);
    }
}
